import { connect } from './lib/react-redux';
import defineStore from './lib/defineStore';
import compose from './lib/redux/compose';
import combineReducers from './lib/redux/combineReducers';
import bindActionCreators from './lib/redux/bindActionCreators';
import invariant from './lib/utils/invariant'; //import warning from './lib/utils/warning'

import __DO_NOT_USE__ActionTypes from './lib/utils/actionTypes';
var _Ext$utils = Ext.utils,
    isArray = _Ext$utils.isArray,
    isPlainObject = _Ext$utils.isPlainObject,
    isString = _Ext$utils.isString,
    noop = _Ext$utils.noop;
Ext.Redux = {
  defineStore: defineStore,
  combineReducers: combineReducers,
  bindActionCreators: bindActionCreators,
  compose: compose,
  usingRedux: usingRedux,
  invariant: invariant,
  __DO_NOT_USE__ActionTypes: __DO_NOT_USE__ActionTypes
};

function usingRedux() {
  return Ext.defaults.redux && Ext.defaults.redux.reducer;
}

function visitState(state, path) {
  try {
    var pathArr = path.split('.');
    return pathArr.reduce(function (val, key) {
      return val[key];
    }, state);
  } catch (e) {
    throw new Error("\u89E3\u6790 state \u5BF9\u8C61\u51FA\u9519\uFF0C\u8BF7\u786E\u4FDD state.".concat(path, " \u5B58\u5728\u5E76\u5408\u6CD5"));
  }
}

function mergeOpts() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  /**
   * 特殊处理数组方式的简写
   * 如 ['a', 'b', 'c.d.e']
   * 会被解析为
   * (state) => ({
   *   a: state.a,
   *   b: state.b,
   *   e: state.c.d.e
   * })
   */
  if (isArray(opts.mapStateToProps)) {
    var states = opts.mapStateToProps;

    opts.mapStateToProps = function (state) {
      return states.reduce(function (prev, current) {
        invariant(isString(current), 'mapStateToProps 数组内容应为字符串，但你输入的是 %s。', current);
        var matched = current.match(/[^\.]+$/);
        invariant(isArray(matched), "%s \u6700\u540E\u4E00\u4E2A '.' \u7684\u540E\u9762\u5E94\u4E3A\u4E00\u4E2A\u5408\u6CD5\u5C5E\u6027\u540D\u3002", current);
        prev[matched[0]] = visitState(state, current);
        return prev;
      }, {});
    };
  } // 特殊处理 dispatcher 的简写
  // 这里直接传入一个对象即可


  if (isPlainObject(opts.mapDispatchToProps)) {
    var actions = opts.mapDispatchToProps;

    opts.mapDispatchToProps = function (dispatch) {
      return Object.keys(actions).reduce(function (prev, current) {
        prev[current] = bindActionCreators(actions[current], dispatch);
        return prev;
      }, {});
    };
  }

  return opts;
}

Ext.addPlugin('redux', noop, noop, function (Component, isView, plugins, name) {
  var options = Component.reduxPlugin;

  if (plugins.indexOf('redux') === -1 || !usingRedux()) {
    // invariant(
    //     !isPlainObject(options),
    //     `如果想使用 redux 插件，请至少配置 'Ext.defaults.redux' 的 'reducer' 属性。`
    // );
    return Component;
  } // 用户使用 redux 但是没有设置 plugin 参数，依旧返回原组件


  if (!options) {
    return Component;
  }

  invariant(isPlainObject(options), "%s \u7EC4\u4EF6\u7684 'reduxPlugin' \u5E94\u8BE5\u662F\u5BF9\u8C61\uFF0C\u4F46\u4F60\u8F93\u5165\u7684\u662F %s\u3002", name, options);
  var opts = mergeOpts(options);
  return connect(opts.mapStateToProps, opts.mapDispatchToProps, opts.mergeProps, opts.options)(Component);
});